export * from './delete-herausgeber.command.module';
export * from './service';
export * from './component';